import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import ActivityTitle from '../ActivityTitle'
import ActivityFooter from '../ActivityFooter'
import ActivityContent from '../ActivityContent'
import type { ActivityTypeComponentProps } from '../Activity'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import Typography from '../../Typography'
import ActivityOwner from '../ActivityOwner'
import QuoteLabel from '../QuoteLabel'
import Highlight from '../../Highlight'
import ActivityDot from '../ActivityDot'

const useStyles = makeStyles<Theme, ActivityTypeComponentProps>((theme: Theme) => ({
  reason: {
    color: theme.palette.text.secondary
  }
}))

export default function QuoteStatusUpdatedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails, showContent } = props
  const classes = useStyles(props)

  const reason = activity.details.events?.[0]

  return (
    <>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> Status Note updated
          </>
        ) : (
          <>
            <Highlight>Status Note </Highlight>updated
          </>
        )}
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      {showContent && reason && (
        <ActivityContent>
          <Typography variant="subtitle2" className={classes.reason}>
            {reason}
          </Typography>
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
